module.exports = __webpack_public_path__ + "static/media/br_border2.6a22c9ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/index/img/br_border2.png
// module id = 1505
// module chunks = 0